import appState from './AppStateContainer';
import {
  getUpdatesStatus,
  NO_UPDATES,
  saveUpdatesDismissed,
  saveUpdatesRead,
  UnreadUpTo,
  UpdatesAnnouncement,
  UpdatesStatus,
} from '../services/newsletterService';

const getStatus = (): UpdatesStatus => appState.state.updatesStatus ?? NO_UPDATES;

export const hasUnreadUpdates = (): boolean => Object.keys(getStatus().unreadUpTo).length > 0;

export const getUnreadUpTo = (): UnreadUpTo => getStatus().unreadUpTo;

export const getUpdatesAnnouncement = (): UpdatesAnnouncement | null => getStatus().announcement;

export const loadUpdatesStatus = async (): Promise<void> => {
  if (!appState.getUserId() || !appState.isCustomerUser() || appState.isSupplierSpecificRoute()) return;
  const updatesStatus = await getUpdatesStatus().catch(() => NO_UPDATES);
  await appState.setState({ updatesStatus });
};

export const markUpdatesRead = (): Promise<void> => {
  saveUpdatesRead(getUnreadUpTo()).catch(() => undefined);
  return appState.setState({ updatesStatus: NO_UPDATES });
};

export const dismissUpdatesAnnouncement = (): Promise<void> => {
  saveUpdatesDismissed(getUnreadUpTo()).catch(() => undefined);
  // An updater, not a snapshot, so a read that lands first is not undone.
  return appState.setState(({ updatesStatus }: { updatesStatus: UpdatesStatus | null }) => ({
    updatesStatus: { ...(updatesStatus ?? NO_UPDATES), announcement: null },
  }));
};
